import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';

// jwt auth
const LoginPage = Loadable(lazy(() => import('pages/auth/Login')));
const RegisterPage = Loadable(lazy(() => import('pages/auth/Register')));
const SelfRegisterPage = Loadable(lazy(() => import('pages/auth/SelfRegister')));
const PricingPage      = Loadable(lazy(() => import('pages/auth/PricingPage')));

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      children: [
        {
          path: '/login',
          element: <LoginPage />
        },
        {
          path: '/register',
          element: <SelfRegisterPage />
        },
        { path: '/pricing',  element: <PricingPage /> },
      ]
    }
  ]
};

export default LoginRoutes;
